import MasterApiBase from "./master-api.base";

/**
 * @typedef {object} RichMenu
 * @property {string} id
 * @property {string} picUrl
 * @property {"defaultRM" | "memberRM"} type
 * @property {boolean} isDisplayed
 * @property {string} template
 * @property {number} width
 * @property {number} height
 * @property {string} createdAt
 * @property {string} updatedAt
 * @property {object[]} areasAction
 * @property {string} areasAction.type
 * @property {string} areasAction.text
 * @property {string} areasAction.uri
 * @property {object[]} areasBounds
 * @property {number} areasBounds.x
 * @property {number} areasBounds.y
 * @property {number} areasBounds.width
 * @property {number} areasBounds.height
 */

export default class RichMenuApi extends MasterApiBase {
	requestKeys = {
		find: "master/findRichMenu",
		create: "master/creationRichMenu",
		createTabGroup: "master/createRichMenuTabGroup",
		updateTabGroup: "master/updateRichMenuTabGroup",
		patch: "master/patchRichMenu",
	};

	async create(data) {
		return this.axios.post(`${this.endpoints.richMenus}`, data, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
	}

	async createTabGroup(data) {
		return this.axios.post("/richmenu-tab-groups", data, {
			headers: { "Content-Type": "application/json" },
		});
	}

	async updateTabGroup(groupId, data, images = []) {
		const formData = new FormData();
		formData.append("data", JSON.stringify({ ...data, groupId }));

		images.forEach((image, i) => {
			formData.append(`richmenu-tab-${i}`, image);
		});

		return this.axios.put(`/richmenu-tab-groups`, formData, {
			headers: { "Content-Type": "multipart/form-data" },
		});
	}

	/**
	 * @typedef {object} FindRichMenuResult
	 * @property {RichMenu} defaultRM
	 * @property {RichMenu[]} memberRM
	 * @property {RichMenu[]} memberCrownRM
	 *
	 * @typedef {object} Params
	 * @property {string} type
	 * @property {boolean} isDisplayed
	 *
	 * @param {Params} params
	 * @returns {Promise<FindRichMenuResult>}
	 */
	async find(params) {
		return this.axios.get(`${this.endpoints.richMenus}`, { params });
	}

	async patch(id, data) {
		return this.axios.patch(`${this.endpoints.richMenus}/${id}`, data, {
			headers: { "Content-Type": "multipart/form-data" },
		});
	}

	async remove(id) {
		return this.axios.delete(`${this.endpoints.richMenus}/${id}`);
	}

	async publish(groupId) {
		return this.axios.put(`/richmenu-tab-groups/${groupId}/publish`);
	}

	async unpublish(groupId) {
		return this.axios.put(`/richmenu-tab-groups/${groupId}/unpublish`);
	}

	async deleteTabGroup(groupId) {
		return this.axios.delete(`/richmenu-tab-groups/${groupId}`);
	}

	async duplicateTabGroup(groupId) {
		return this.axios.put(`/richmenu-tab-groups/${groupId}/duplicate`);
	}
}
